// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap--3l7T5","box":"box--3BR9T"};